module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('block', {
    attrs: {
      "title": "Projets personnels"
    }
  }, [_c('div', {
    attrs: {
      "id": "projects"
    }
  }, [_vm._l((_vm.projects), function(project) {
    return [_c('list-item', [_c('a', {
      staticClass: "title",
      attrs: {
        "href": project.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(project.title))]), _vm._v(" "), _c('span', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(project.description)
      }
    }), _c('br'), _vm._v(" "), _vm._l((project.skills), function(skill) {
      return [_c('chips', [_vm._v(_vm._s(skill))])]
    })], 2)]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eca3c618"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects.vue
// module id = 303
// module chunks = 1